import { rootApi } from 'root-api-graphql'
import { Periods } from 'services/search_api/constants'
import { buildFilterString } from 'services/search_api/utils'

import { recapFilters } from './constants'

const buildSearchMeetingsQuery = (variables) => {
  const filterString = buildFilterString(variables)

  return `
  query getMeetings(
    $query: String!,
    $searchIn: [MeetingSearchInFields!],
  ) {
    meetings_search(
      input: {
        query: $query,
        searchIn: $searchIn,
        filter: {${filterString}}
      }
    ) {
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
      edges {
        node {
          uuid
          owner_user_uuid
          name
          startTime: start_time
          endTime: end_time
          ... on CalendlyMeeting {
            eventType: event_type {
              color
            }
          }
          meeting_intelligence {
              uuid
              status
              recap_permission
          }
          attendees {
            kind
            email
            name
            ... on InviteeAttendee {
              uuid
              cancelled
            }
            ... on HostAttendee {
              uuid
            }
            ... on CoHostAttendee {
              uuid
            }
          }
        }
      }
      total
    }
  }
`
}

const buildGetMeetingsQuery = (variables) => {
  const filterString = buildFilterString(variables)

  return `
    query getMeetings($first: Int, $before: String, $after: String) {
      meetings(input: {
        pagination: {first: $first, before: $before, after: $after}
        filter: {${filterString}}
        orderBy: {start_time: DESC}
      }) {
        total
        edges {
          node {
            uuid
            owner_user_uuid
            kind
            name
            cancelled
            status
            start_time
            end_time
            ... on CalendlyMeeting {
              event_type {
                color
              }
            }
            meeting_intelligence {
              uuid
              status
              recap_permission
            }
            attendees {
              kind
              name
              email
              timezone
              ... on InviteeAttendee {
                uuid
                cancelled
              }
              ... on HostAttendee {
                uuid
              }
              ... on CoHostAttendee {
                uuid
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }
  `
}

const buildHasAnyRecapsQuery = () => {
  const filterString = buildFilterString({
    ...recapFilters,
    period: Periods.UPCOMING,
    recapScope: 'ALL_RECAPS',
  })

  return `
  query hasAnyRecaps {
    meetings(input: {
      pagination: { first: 1 }
      filter: {${filterString}}
      orderBy: { start_time: DESC }
    }) {
      total
    }
  }
`
}

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    searchMeetingRecaps: build.query({
      query: (variables) => ({ document: buildSearchMeetingsQuery(variables), variables: { ...variables, first: 45 } }),
      transformResponse: (response) => ({ meetings: response.meetings_search }),
      providesTags: ['MeetingSearchResult'],
      serializeQueryArgs: ({
        queryArgs: {
          query, sortBy, first, searchIn, recapScope
        }
      }) => ({ query, sortBy, first, searchIn, recapScope })
    }),
    getMeetingRecaps: build.query({
      query: (variables) => ({ document: buildGetMeetingsQuery(variables), variables: { ...variables, first: 45 } }),
      providesTags: ['MeetingRecaps'],
    }),
    hasAnyRecaps: build.query({
      query: () => ({ document: buildHasAnyRecapsQuery() }),
      transformResponse: (response) => ({ total: response.meetings.total }),
      providesTags: ['MeetingRecaps'],
    }),
  })
})

export const {
  useSearchMeetingRecapsQuery,
  useGetMeetingRecapsQuery,
  useLazyGetMeetingRecapsQuery,
  useHasAnyRecapsQuery
} = api
